import {TypeFicheExpressionBesoinEnum} from './enum/TypeFicheExpressionBesoin.enum';
import {Status} from './fichePreparation';

export class FichePreparationFilter {

  preparateur: number;
  status: Status;
  usine: number;
  OT: string;
  num_avis: string;

  actif: boolean;
  preparee: string;
  no_caisse: string;
  page: number;
  pageSize: number;
  simple: boolean;
  atelier: number;
  text: string;
  listStatus: Status[];
  listPreparateur: number[];
  listAtelier: string[];
  listUsine: number[];

  // Filtres des fiches expression besoin
  dateDebut: Date;
  dateFin: Date;
  listType: TypeFicheExpressionBesoinEnum[];

  visiteChantier: boolean | null;
}
